<template>
  <div class="left400 fl">
    <div class="bor">
      <div class="tit-mod-secs clearfix">
        <h3 class="fl font-s16">快捷服务</h3>
        <!-- <a href="/info?type=1" class="more2 font-s14" target="_blank"
          >查看更多&gt;</a
        > -->
      </div>
    </div>
    <div class="fastMenu">
      <ul>
        <li>
          <a href="/certificate?type=1">
            <span class="icon fa icon-category"></span>
            <p>考试介绍</p>
          </a>
        </li>
        <li>
          <a href="/zhinan?type=2">
            <span class="icon fa icon-all"></span>
            <p>课程体系</p>
          </a>
        </li>
        <li>
          <a href="/register">
            <span class="icon fa icon-suggest"></span>
            <p>报名注册</p>
          </a>
        </li>
        <li>
          <a href="/certificate?type=3">
            <span class="icon fa icon-integral-fill"></span>
            <p>证书收益</p>
          </a>
        </li>
        <li>
          <a href="/course">
            <span class="icon fa icon-yonghu"></span>
            <p>学习中心</p>
          </a>
        </li>
        <li>
          <a href="/certificate?type=2">
            <span class="icon fa icon-shenqingjilu"></span>
            <p>证书样本</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  setup() {},
};
</script>
<style lang="scss" scoped>
a,
a:link {
  cursor: pointer;
  color: #333;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  color: #04407d;
}

.left820 {
  width: 795px;
}
.left400 {
  width: 580px;
  font-family: "Microsoft YaHei", "微软雅黑" !important;
}
.left400 .bor {
  width: 580px;
  padding-top: 20px;
}
.noticeList {
  height: 440px;
  overflow: hidden;
}
.blank20 {
  clear: both;
  height: 20px;
  overflow: hidden;
  display: block;
}
.fastMenu ul {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.fastMenu ul li {
  // background: red;
  width: 30%;
  height: 150px;
  margin-top: 22px;
  a {
    height: 100%;
    display: block;
    border: 2px solid #035fa6;
    text-align: center;
    span.icon {
      font-size: 60px;
      color: #035fa6;
      line-height: 70px;
      margin-top: 15px;
          display: inline-block;
    }
    p {
      font-size: 25px;
      font-family: "Poppins", sans-serif;
      font-weight: 600;
    }
  }
  a:hover{
    background: #035fa6;
    color: #fff;
    span.icon{
        color: #fff;
    }
  }
}
</style>